import React from "react";

import Typography from "@material-ui/core/Typography";
import styled from "styled-components/macro";

import { Column } from "components/Layout";

import { space } from "constants/theme";

import { getLivestockSaleId } from "lib/navigation";

const ResolutionList = styled.ul`
  margin: ${({ theme }) => theme.space[1]}px 0 0;
  padding-left: ${({ theme }) => theme.space[3]}px;
`;

interface TemporaryBusinessIntroProps {
  // Without one, explains temporary Businesses in general.
  business?: Business;
}

export function TemporaryBusinessIntro({
  business,
}: TemporaryBusinessIntroProps) {
  const isInSale =
    Boolean(business) &&
    getLivestockSaleId() === business.addedInLivestockSaleId;
  return (
    <Column
      padding={2}
      marginTop={1}
      background="gray95"
      style={{ marginBottom: space[2] }}
    >
      <Typography paragraph>
        {!business
          ? "Temporary businesses are created during a sale, and can't be searched for or selected outside of the sale they were created in."
          : isInSale
            ? "This is a temporary business. It was created during this sale, and can't be searched for or selected outside of it."
            : "This is a temporary business. It was created during a sale, and can't be searched for or selected outside of that sale."}
      </Typography>
      <Typography>
        {business ? "You can:" : "For each one, you can:"}
      </Typography>
      <ResolutionList>
        <li>
          <Typography>
            <strong>Use</strong> &ndash; Merge it with the auto-matched or
            searched business.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Activate</strong> &ndash; Keep it as a genuinely new
            business. Clear any auto-match to activate it.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Inactivate</strong> &ndash; Limit it to{" "}
            {isInSale ? "this sale" : "the sale it was created in"} only.
          </Typography>
        </li>
      </ResolutionList>
    </Column>
  );
}
